/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { useContext } from "react";
import DateRange from "./DateRange";
import { Location } from "SearchParameters";
import { useMutation } from "@tanstack/react-query";
import { saveLocation } from "../../api";
import { AuthenticatedContext } from "../Authenticated/Authenticated";
import { DateTime } from "luxon";
import Dropdown from "./Dropdown";
import { MenuItem } from "@mui/material";
import { AxiosError } from "axios";

const SearchParameters = () => {
  const {
    getLatestUserPreferences,
    endDate,
    setEndDate,
    locationOptions,
    currentLocation,
    setCurrentLocation,
    handleError,
  } = useContext(AuthenticatedContext);

  const mutation = useMutation({
    mutationFn: (location: Location) => {
      return saveLocation(location);
    },
    onError: (err: AxiosError) => handleError(err),
  });

  const handleLocationChange = (location: Location) => {
    setCurrentLocation(location);
    mutation.mutate(location);
    getLatestUserPreferences();
  };

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <div
        style={{
          paddingLeft: 10,
          paddingRight: 10,
          display: "flex",
        }}
      >
        <DateRange endDate={endDate as DateTime} setEndDate={setEndDate} />
      </div>
      <div
        style={{
          minWidth: 92,
        }}
      >
        <Dropdown
          label="Location"
          value={currentLocation}
          setter={handleLocationChange}
        >
          {locationOptions && locationOptions.length > 0 ? (
            locationOptions!.map((location: Location) => (
              // @ts-ignore
              <MenuItem key={location.location} value={location}>
                {location.location}
              </MenuItem>
            ))
          ) : (
            // @ts-ignore
            <MenuItem value={currentLocation!}>UNK</MenuItem>
          )}
        </Dropdown>
      </div>
    </div>
  );
};

export default SearchParameters;
